import React from 'react';
import { useDispatch } from 'react-redux';
import {setSearchTerm, setLandingIsActive} from "../../Features/Misc/activeSlice";





const BackToLandingButton = () => {
    const dispatch = useDispatch();



    const handleBackClick = () => {

        dispatch(setSearchTerm(''));
        dispatch(setLandingIsActive())
    };

    return (
        <button
            onClick={handleBackClick}
            className="
                hidden
                lg:flex
                justify-center
                items-center
                text-white
                border-2
                border-gold-accent
                rounded-lg

                py-3
                px-4
                sm:px-14

                lg:text-lg

                font-medium
                cursor-pointer

                hover:opacity-60 transition-opacity duration-300 transition-border"
        >
            <i className="ri-arrow-left-line mr-3"></i>
            Back to Home
        </button>
    );
};

export default BackToLandingButton;